/* import __COLOCATED_TEMPLATE__ from './copilot-seat-metadata.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();